import React, { useState, useEffect, useCallback } from 'react';
import {
  Table, Typography, Menu, Dropdown, Checkbox, Button, Select, Row, Col
} from 'antd';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import AdvancedSearchForm from '../../../common/SearchForm';

const { Title } = Typography;
const { Option } = Select;

function Locations(props) {
  const [locations, setLocations] = useState([]);
  const [searchOption, setSearchOption] = useState(false);

  const renderData = useCallback(() => {
    props.getAllEquipmentCities.call();
    props.getAllEquipmentSupportedLocations.call();
  }, [props.getAllEquipmentCities, props.getAllEquipmentSupportedLocations, props.updateSupportedLocation])

  // useEffect(() => {
  //   props.getAllEquipmentCities();
  //   props.getAllEquipmentSupportedLocations();
  // }, []);

  useEffect(() => {
    renderData();
  }, [renderData]);

  // useEffect(() => {
  //   props.getAllEquipmentCities();
  //   props.getAllEquipmentSupportedLocations();
  // }, [props.updateSupportedLocation]);

  useEffect(() => {
    setLocations(props.equipmentSupportedLocations);
  }, [props.equipmentSupportedLocations]);

  const columns = [
    {
      title: 'City',
      key: 'name',
      render: (_, columnData) => (
        <div>{`${columnData.name}`}</div>
      ),
      width: 250,
    },
    {
      title: 'State',
      key: 'state',
      render: (_, columnData) => (
        <div>{` ${columnData.state}`}</div>
      ),
      width: 250,
    },
    {
      title: 'Country',
      key: 'country',
      render: (_, columnData) => (
        <div>{` ${columnData.country}`}</div>
      ),
      width: 250,
    },
  ];
  function onChange(e) {
    const obj = props.equipmentAllCities.reduce((acc, cur) => ({ ...acc, [`${cur.id}`]: cur.supported }), {});
    if (e.target.checked) {
      obj[e.target.value] = 1;
    } else {
      obj[e.target.value] = 0;
    }
    const payloadObj = {
      payload: { city: obj },
    };
    props.updateAllEquipmentSupportedLocations(payloadObj);
  }
  const menu = (
    <Menu>
      {
        props.equipmentAllCities && props.equipmentAllCities.map((city) => (
          <div style={{ margin: 'auto' }} key={city.id}>
            {/* <Menu.Item key={city.id}> */}
            <Checkbox style={{ margin: '5px' }} key={city.id} value={city.id} onChange={(e) => onChange(e)} checked={city.supported}>
              {city.name}
            </Checkbox>
            {/* </Menu.Item> */}
            {/* <Menu.Divider /> */}
          </div>
        ))
      }
    </Menu>
  );
  const onSearch = (values) => {
    if (Object.keys(values).length === 0 && values.constructor === Object) {
      setLocations(props.equipmentSupportedLocations);
      return;
    }
    const filtered = Object.values(values).filter((x) => x !== undefined);
    if (filtered.length === 0) {
      setLocations(props.equipmentSupportedLocations);
      return;
    }
    let locationsNew = [];
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues);
    locationsNew = queryString.map((val) => props.equipmentSupportedLocations.filter((value) => newValues[val] && value[val].toUpperCase().includes(newValues[val].toUpperCase())));
    locationsNew = locationsNew.reduce((acc, val) => acc.concat(val), []).filter((v, i, a) => a.findIndex((t) => (t.id === v.id)) === i);
    setLocations(locationsNew);
  };
  const toggleSearch = () => {
    setSearchOption(!searchOption)
  }
  return (
    <div className='delivery-location'>
      <Row
        gutter={[0, 16]}
      >
        <Col className="gutter-row section-heading" span={12} offset={0}>
          <Title
            level={2}
            className="d-flex title"
          >
            Delivery Locations
          </Title>
          <span
            className="d-flex sub-title"
          // style={{ justifyContent: 'space-between', alignItems: 'center' }}
          >
            Local city support for delivery of Rental / Purchase products.
          </span>
        </Col>
        <Col className="gutter-row" span={5} offset={0}>
        </Col>
        <Col className="gutter-row header-buttons" span={3} offset={0}>
          <Button className={`${searchOption === true ? 'search-open' : 'search-close'} search-toggle-button`} onClick={() => toggleSearch()}>
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col className="gutter-row header-dropdown" span={4} offset={0}>
          <Dropdown overlay={menu} trigger={['click']}>
            <Button className="search-close">
              <span onClick={(e) => e.preventDefault()}>
                Select Cities
              </span>
              <DownOutlined />
            </Button>
          </Dropdown>
        </Col>
      </Row>
      {searchOption === true ?
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Users"
          formItems={[
            {
              key: 'name',
              label: 'City',
            },
            {
              key: 'state',
              label: 'State',
            },
            {
              key: 'country',
              label: 'Country',
              Component: (
                <Select placeholder="Select Country" size="large">
                  <Option value="India">India</Option>
                  <Option value="United Kingdom">United Kingdom</Option>
                  <Option value="Australia">Australia</Option>
                  <Option value="United States of America">United States of America</Option>
                </Select>
              ),
            },
          ]}
        />
        : ""}
      <Table className='list_table ' dataSource={locations} columns={columns} scroll={{ x: 800 }} />
    </div>
  );
}

export default Locations;
